import { type Descendant, Editor, Element, Text } from 'slate';

// Add an empty text node before and after any inline elements
// in the children array.
//
// Used when deserializing HTML for efficiency. If we don't do
// this, Slate will add the empty text nodes through its
// normalization passes, which is considerably more expensive.
export default function addEmptyTextAtInlineEdges(
  editor: Editor,
  nodes: Descendant[]
) {
  let i = 0;

  while (i < nodes.length) {
    const child = nodes[i];
    const prevChild = i > 0 ? nodes[i - 1] : null;
    const isInline = Element.isElement(child) && Editor.isInline(editor, child);

    if (isInline) {
      // If this is an inline element, we need to ensure that it has a
      // text node before it.
      if (!prevChild || !Text.isText(prevChild)) {
        nodes.splice(i, 0, { text: '' });
      }

      // If this is the last child and it's an inline element, add an
      // empty text node after it.
      if (i === nodes.length - 1) {
        nodes.push({ text: '' });
      }
    }

    i++;
  }

  return nodes;
}
